import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import { formatMoney } from '../../common/utils/currency';
import { safeHref } from '../../common/utils/safeHref';
function resolveType(meta) {
  if (meta.is_pool) return {
    key: 'pool',
    icon: 'fas fa-ticket-alt',
    labelKey: 'pool'
  };
  if (meta.is_composer) return {
    key: 'composer',
    icon: 'fab fa-php',
    labelKey: 'composer'
  };
  if (meta.type === 'service') return {
    key: 'service',
    icon: 'fas fa-concierge-bell',
    labelKey: 'service'
  };
  if (meta.type === 'physical') return {
    key: 'physical',
    icon: 'fas fa-box',
    labelKey: 'physical'
  };
  return {
    key: 'digital',
    icon: 'fas fa-cloud-download-alt',
    labelKey: 'digital'
  };
}
/**
 * Modal exibido ao clicar num card de produto incorporado num post.
 * Mostra detalhes completos sem precisar abrir nova aba.
 */
export default class MpProductEmbedModal extends Modal {
  className() {
    const t = resolveType(this.attrs.meta);
    return `Modal--medium MpEmbedModal MpEmbedModal--${t.key}`;
  }
  title() {
    return this.attrs.meta.name || '';
  }
  t(k, vars) {
    return app.translator.trans('ramon-marketplace.forum.embed.modal.' + k, vars);
  }
  tt(k) {
    return app.translator.trans('ramon-marketplace.forum.embed.' + k);
  }
  content() {
    const meta = this.attrs.meta;
    const t = resolveType(meta);
    const typeLabel = this.tt('types.' + t.labelKey);
    const desc = meta.description_full || meta.description || '';
    const isFree = meta.is_open_source || (meta.price ?? 0) === 0;
    const hasRating = !!(meta.reviews_count && meta.rating);
    const showDetails = meta.is_composer && meta.package_name || !!meta.billing_cycle;
    return m("div", {
      className: "Modal-body MpEmbedModal-body"
    }, m("div", {
      className: "MpEmbedModal-hero"
    }, m("div", {
      className: "MpEmbedModal-thumb"
    }, meta.image_url ? m("img", {
      src: meta.image_url,
      alt: "",
      loading: "lazy"
    }) : m("i", {
      className: t.icon
    })), m("div", {
      className: "MpEmbedModal-heroInfo"
    }, m("div", {
      className: "MpEmbedModal-meta"
    }, m("span", {
      className: `MpEmbedModal-typeChip MpEmbedModal-typeChip--${t.key}`
    }, m("i", {
      className: t.icon
    }), " ", typeLabel), meta.category && m("span", {
      className: "MpEmbedModal-cat"
    }, meta.category), meta.is_open_source && m("span", {
      className: "MpEmbedModal-tag MpEmbedModal-tag--free"
    }, m("i", {
      className: "fas fa-code-branch"
    }), " ", this.tt('oss'))), m("div", {
      className: "MpEmbedModal-priceRow"
    }, isFree ? m("span", {
      className: "MpEmbedModal-priceFree"
    }, this.tt('free')) : meta.dual_billing && meta.price_yearly ? m("span", {
      className: "MpEmbedModal-price"
    }, m("strong", null, formatMoney(meta.price ?? 0)), m("small", null, this.tt('per_month')), m("span", {
      className: "MpEmbedModal-sep"
    }, "\xB7"), m("strong", null, formatMoney(meta.price_yearly)), m("small", null, this.tt('per_year'))) : m("span", {
      className: "MpEmbedModal-price"
    }, m("strong", null, formatMoney(meta.price ?? 0)), meta.billing_cycle === 'monthly' && m("small", null, this.tt('per_month')), meta.billing_cycle === 'yearly' && m("small", null, this.tt('per_year'))), hasRating ? m("span", {
      className: "MpEmbedModal-rating"
    }, m("i", {
      className: "fas fa-star"
    }), " ", m("span", null, meta.rating.toFixed(1)), m("small", null, this.t('reviews_count', {
      count: meta.reviews_count
    }))) : m("span", {
      className: "MpEmbedModal-rating MpEmbedModal-rating--empty"
    }, m("i", {
      className: "far fa-star"
    }), " ", this.t('no_reviews'))))), m("div", {
      className: "MpEmbedModal-section"
    }, m("h4", {
      className: "MpEmbedModal-sectionTitle"
    }, this.t('description')), desc ? m("p", {
      className: "MpEmbedModal-desc"
    }, desc) : m("p", {
      className: "MpEmbedModal-desc MpEmbedModal-desc--empty"
    }, this.t('no_description'))), showDetails && m("div", {
      className: "MpEmbedModal-section"
    }, m("h4", {
      className: "MpEmbedModal-sectionTitle"
    }, this.t('details')), m("dl", {
      className: "MpEmbedModal-details"
    }, meta.is_composer && meta.package_name && m("div", {
      className: "MpEmbedModal-detailRow"
    }, m("dt", null, this.t('package')), m("dd", null, m("code", null, meta.package_name))), meta.billing_cycle && m("div", {
      className: "MpEmbedModal-detailRow"
    }, m("dt", null, this.t('billing')), m("dd", null, this.billingLabel())))), m("div", {
      className: "MpEmbedModal-actions"
    }, m("button", {
      type: "button",
      className: "MpBtn MpBtn--ghost MpEmbedModal-close",
      onclick: () => app.modal.close()
    }, this.t('close')), m("a", {
      href: safeHref(meta.url),
      className: "MpBtn MpBtn--primary MpEmbedModal-open",
      target: "_blank",
      rel: "noopener noreferrer"
    }, this.t('open'), " ", m("i", {
      className: "fas fa-arrow-right"
    }))));
  }
  billingLabel() {
    const meta = this.attrs.meta;
    if (meta.dual_billing) return this.t('billing_dual');
    if (meta.billing_cycle === 'monthly') return this.t('billing_monthly');
    if (meta.billing_cycle === 'yearly') return this.t('billing_yearly');
    return this.t('billing_one_time');
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/MpProductEmbedModal', MpProductEmbedModal);